/* eslint-disable max-len */
export const RANGE_ANIMATIONS = {
  FIVE_EASY_STEPS: 'https://dam.thdstatic.com/content/production/HCH7BLdVbBDlRaSKb4669g/zFblzMgkby-QRMCgmsQRkg/Original%20file/d29a-major-appliance-delivery-ux--first-page-animation-1224.gif',
  DELIVERY_PATH: 'https://dam.thdstatic.com/content/production/iAcHY0fVj6q0Cd3f3O_JoQ/HtQRXYYKdBCxeM3thUkrtQ/Original%20file/7585206-d29a-major-appliciance-fit-compatibility-range-delivery-path-500x500.gif',
  FREESTANDING_HEIGHT: 'https://dam.thdstatic.com/content/production/sQXLCMLbbC5b28FOuN3oVw/-FJYGI11aqtCY0SjIVkUJg/Original%20file/7585206-d29a-major-appliciance-fit-compatibility-range-freestanding-height-500x500.gif',
  FREESTANDING_WIDTH: 'https://dam.thdstatic.com/content/production/t40ohYop0UZSYrJjCh7gtw/Iy6iNSUkQ-Zmj-wWTfbFZw/Original%20file/7585206-d29a-major-appliciance-fit-compatibility-range-freestanding-width-500x500-v2.gif',
  SLIDE_IN_HEIGHT: 'https://dam.thdstatic.com/content/production/QQ76PM6dG4TGw7jLWLYS4A/u3OxtjDazRtjp-DWjSvfZw/Original%20file/7585206-d29a-major-appliciance-fit-compatibility-range-slide-in-height-500x500.gif',
  SLIDE_IN_WIDTH: 'https://dam.thdstatic.com/content/production/1rc_LN9b7YeRsiaZ1IwFzg/eaihtmumjlevRNetTqC-dA/Original%20file/7585206-d29a-major-appliciance-fit-compatibility-range-slide-in-width-500x500.gif',
  RANGE_DEPTH: 'https://dam.thdstatic.com/content/production/7AoGwfWSpI0murDRKtBSAA/Y1z9EMdvglv983SoJo0i-w/Original%20file/7585206-d29a-major-appliciance-fit-compatibility-range-range-depth-500x500.gif',
  RANGE_DOOR_DEPTH: 'https://dam.thdstatic.com/content/production/D8jSy9nsFJ-dmeTemomV-w/uS3bXmh_GnGlfaajP3DMVg/Original%20file/7585206-d29a-major-appliciance-fit-compatibility-range-door-depth-500x500.gif'
};

export const RANGE_IMAGES = {
  THREE_PRONG: 'https://dam.thdstatic.com/content/production/cSJbmAafvUhV0tmOtl4i8Q/pCmGV1uNFJ-ctcFNSzLkog/Original%20file/7321000-d29a-oven-outlet-125-250-volt-3-prong_05-08-2025.svg',
  FOUR_PRONG: 'https://dam.thdstatic.com/content/production/zmT-6Itws71fRxamKRxz0w/x51hmNyepJopin663wEFZA/Original%20file/7321000-d29a-oven-outlet-125-250-volt-4-prong_05-08-2025.svg',
  GAS: 'https://dam.thdstatic.com/content/production/dS1LjuiGlHK3PpPb7n4KoA/fI2aJx_uv-oLOVOB2TX_Tg/Original%20file/7321000-d29a-gas-valve-v3.svg',
  ELECTRIC: 'https://dam.thdstatic.com/content/production/SobKqOHiNAp4DkDxpnUsDg/AvcBm6ZXoJNvXD09z9GJMg/Original%20file/7321000-d29a-outlet-120-volt-3-prong-v3.svg',
  FREESTANDING: 'https://dam.thdstatic.com/content/production/fHMZmvU2r_2cNzNkHeP_Pg/IlfVmb5Z0eMY2IgltntFWA/Original%20file/7585206-d29a-major-appliciance-fit-compatibility-freestanding-range-418px-wide-no-white-space.svg',
  SLIDE_IN: 'https://dam.thdstatic.com/content/production/z0s_mJVAM40H5uNq3DpvtA/YcRbaSJfU_TGeYD1_eBj0w/Original%20file/7585206-d29a-major-appliciance-fit-compatibility-slide-in-range-418px-wide-white-space-on-top.svg',
};

export const RANGE_DRAWER_MAPPING = [
  // Page 1
  {
    header: 'Make Sure It Fits',
    sections: [
      {
        text: {
          id: 'text_0',
          string: 'Let\'s Measure Your Space In Five Easy Steps',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_1',
          string: 'Accurate measurements will ensure a perfect fit for your new range. You\'ll need a tape measure and be ready to take notes.'
        }
      },
      {
        image: {
          id: 'image_0',
          src: RANGE_ANIMATIONS.FIVE_EASY_STEPS,
          alt: 'Five Easy Steps',
          size: '100%'
        }
      },
      {
        tip: {
          id: 'tip_0',
          strings: [
            'You\'re not measuring your old range. Focus on the space it will be installed and clear a path for delivery.'
          ]
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_2',
          string: 'Need help measuring? Please call your local store for more information.'
        }
      }
    ],
    footer: 'Next'
  },
  // Page 2
  {
    header: 'Step 1 of 5',
    sections: [
      {
        text: {
          id: 'text_3',
          string: 'Map Your Delivery Path',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_4',
          string: 'We want delivery and installation to go easy for you.'
        }
      },
      {
        text: {
          id: 'text_5',
          string: 'Our experts suggest:'
        },
        modifiers: {
          marginOverride: 2
        }
      },
      {
        list: {
          id: 'list_0',
          items: [
            'Find a route with the least obstacles from the delivery truck to the installation location.',
            'Measure your front door, interior doors, hallways and tight spaces along this path.',
            'Take note of the narrowest gap and tight turns.'
          ]
        }
      },
      {
        image: {
          id: 'image_1',
          src: RANGE_ANIMATIONS.DELIVERY_PATH,
          alt: 'Range Delivery Path',
          size: '100%'
        }
      },
      {
        text: {
          id: 'text_6',
          string: 'This will help you know if your range will clear the delivery path.'
        }
      },
      {
        tip: {
          id: 'tip_1',
          strings: [
            'Consider removing doors if necessary prior to the delivery. Be prepared to remove furniture, decor and rugs along the path on delivery day.'
          ]
        },
        modifiers: {
          hasBorder: true
        }
      }
    ],
    footer: 'Next'
  },
  // Page 3
  {
    header: 'Step 2 of 5',
    sections: [
      {
        text: {
          id: 'text_7',
          string: 'Check Your Range Connection: Gas or Electric',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_8',
          string: 'Use the information below to confirm your range power source. Keep in mind, there are a few ranges that have dual fuel hookups.'
        }
      },
      {
        text: {
          id: 'text_9',
          boldString: 'Electric ',
          string: 'ranges require a 240-Volt outlet for three or four-prong electrical outlet within 4 feet of your new appliances.',
        },
        modifiers: {
          marginOverride: 6
        }
      },
      {
        text: {
          id: 'text_10',
          string: 'Induction ranges require the same hookup as electric.'
        }
      },
      {
        imageSeparator: {
          id: 'imageSeparator_0',
          separator: 'or',
          items: [
            {
              image: {
                id: 'image_2',
                src: RANGE_IMAGES.THREE_PRONG,
                alt: '3-Prong 240-Volt',
                height: '100px',
                width: '100px',
                subHeader: '3-Prong 240-Volt'
              }
            },
            {
              image: {
                id: 'image_3',
                src: RANGE_IMAGES.FOUR_PRONG,
                alt: '4-Prong 240-Volt',
                height: '100px',
                width: '100px',
                subHeader: '4-Prong 240-Volt'
              }
            },
          ]
        },
        modifiers: {
          marginOverride: 6,
          flexGroup: true,
        }
      },
      {
        text: {
          id: 'text_11',
          boldString: 'Gas ',
          string: 'ranges require a gas supply pipe with a shut-off valve directly behind the range and a standard 120-Volt outlet.'
        },
        modifiers: {
          marginOverride: 6
        }
      },
      {
        imageSeparator: {
          id: 'imageSeparator_1',
          separator: 'plus',
          items: [
            {
              image: {
                id: 'image_4',
                src: RANGE_IMAGES.GAS,
                alt: 'Gas Valve',
                height: '80px',
                width: '143px',
                subHeader: 'Gas Valve'
              }
            },
            {
              image: {
                id: 'image_5',
                src: RANGE_IMAGES.ELECTRIC,
                alt: '3-Prong 120-Volt',
                height: '65px',
                width: '70px',
                subHeader: '3-Prong 120-Volt',
              }
            },
          ]
        },
        modifiers: {
          marginOverride: 6,
          flexGroup: true,
        }
      },
      {
        text: {
          id: 'text_12',
          string: 'For clarity, the gas valve illustration is shown open. Always shut if off before maintenance, installation or inspection.'
        }
      },
      {
        tip: {
          id: 'tip_2',
          strings: [
            'Look up the model of the current appliance to confirm the connection. Model numbers can usually be found on the door, back or side of appliances.'
          ]
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_13',
          string: 'Make sure to purchase new required parts as old parts might void the warranty of your new appliance. Some parts come with the purchase of installation.'
        }
      }
    ],
    footer: 'Next'
  },
  // Page 4
  {
    header: 'Step 3 of 5',
    sections: [
      {
        text: {
          id: 'text_14',
          string: 'Measure the Width',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_15',
          string: 'Before you measure, consider the the type of range that works best for your space: Slide-in or Freestanding.'
        },
        modifiers: {
          marginOverride: 6
        }
      },
      {
        tabs: {
          id: 'tabs_0',
          items: [
            {
              id: 'tab_0',
              label: 'Slide-in',
              content: [
                {
                  text: {
                    id: 'text_16',
                    string: 'Slide-in ranges are designed to be installed flush with cabinetry and countertops, creating a sleek, integrated look. They don\'t have finished sides and typically have the controls in the front.',
                  },
                  modifiers: {
                    marginOverride: 6
                  }
                },
                {
                  sections: {
                    id: 'sections_2',
                    items: [
                      {
                        image: {
                          id: 'image_6',
                          src: RANGE_IMAGES.SLIDE_IN,
                          alt: 'Slide-in Range Width',
                          size: '45%',
                          subHeader: 'Slide-in'
                        },
                        modifiers: {
                          ranges: true
                        }
                      }
                    ]
                  },
                  modifiers: {
                    marginOverride: 6
                  }
                },
                {
                  text: {
                    id: 'text_17',
                    string: 'Now, measure the space where your range will go. Take note of the width in two places:',
                  }
                },
                {
                  list: {
                    id: 'list_1',
                    items: [
                      'at the top of the cabinet or island opening',
                      'at the floor of the cabinet or island opening',
                    ]
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_18',
                    string: 'If the two measurements do not match, use the lower one for width. You can fill in any gaps with cabinet trim.'
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  image: {
                    id: 'image_7',
                    src: RANGE_ANIMATIONS.SLIDE_IN_WIDTH,
                    alt: 'Slide-in Measure Width Gif',
                    size: '100%',
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  tip: {
                    id: 'tip_3',
                    strings: [
                      'Add about 1/4-inch to your width measurement. This will help your new range fit well and slide in easily.'
                    ]
                  },
                  modifiers: {
                    hasBorder: true,
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_19',
                    string: 'Many slide-in ranges are about 30"-60" in width. If you have more space, you can consider an extra-wide commercial style. If you have less space, consider a compact style.',
                    isTiny: true
                  }
                },
              ]
            },
            {
              id: 'tab_1',
              label: 'Freestanding',
              content: [
                {
                  text: {
                    id: 'text_20',
                    string: 'Freestanding ranges feature finished sides and a backguard that allow them to be installed between cabinets or on their own, making them a flexible choice for most kitchens.',
                  },
                  modifiers: {
                    marginOverride: 6
                  }
                },
                {
                  sections: {
                    id: 'sections_3',
                    items: [
                      {
                        image: {
                          id: 'image_8',
                          src: RANGE_IMAGES.FREESTANDING,
                          alt: 'Freestanding Range Width',
                          size: '45%',
                          subHeader: 'Freestanding',
                        },
                        modifiers: {
                          ranges: true
                        }
                      }
                    ],
                  },
                  modifiers: {
                    marginOverride: 6
                  }
                },
                {
                  text: {
                    id: 'text_21',
                    string: 'Now, measure the space where your range will go. Take note of the width in two places:'
                  },
                  modifiers: {
                    marginOverride: 2
                  }
                },
                {
                  list: {
                    id: 'list_2',
                    items: [
                      'at the top of the installation space',
                      'at the floor of the installation space',
                    ]
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_22',
                    string: 'If the two measurements do not match, use the lower one for width.'
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  image: {
                    id: 'image_9',
                    src: RANGE_ANIMATIONS.FREESTANDING_WIDTH,
                    alt: 'Freestanding Range Width Gif',
                    size: '100%',
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  tip: {
                    id: 'tip_4',
                    strings: [
                      'Add about 1/4-inch to your width measurement. This will help your new range fit well and slide in easily.'
                    ]
                  },
                  modifiers: {
                    hasBorder: true,
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_23',
                    string: 'Many freestanding ranges are about 30"-48" in width. If you have more space, you can consider an extra-wide commercial style. If you have less space, consider a compact style.',
                    isTiny: true
                  }
                }
              ]
            }
          ]
        }
      }
    ],
    footer: 'Next'
  },
  // Page 5
  {
    header: 'Step 4 of 5',
    sections: [
      {
        text: {
          id: 'text_24',
          string: 'Measure the Height',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_25',
          string: 'Before you measure, consider the the type of range that works best for your space: Slide-in or Freestanding.'
        },
        modifiers: {
          marginOverride: 6
        }
      },
      {
        tabs: {
          id: 'tabs_1',
          items: [
            {
              id: 'tab_2',
              label: 'Slide-in',
              content: [
                {
                  sections: {
                    id: 'sections_4',
                    items: [
                      {
                        image: {
                          id: 'image_10',
                          src: RANGE_IMAGES.SLIDE_IN,
                          alt: 'Slide-in Range Height',
                          size: '45%',
                          subHeader: 'Slide-in',
                        },
                        modifiers: {
                          ranges: true,
                        }
                      }
                    ]
                  },
                  modifiers: {
                    marginOverride: 6,
                  }
                },
                {
                  text: {
                    id: 'text_26',
                    string: 'Measure from the floor to the top of your cabinet or island. Floors can warp so take three measurements.',
                  }
                },
                {
                  list: {
                    id: 'list_3',
                    items: [
                      'floor to top of right cabinet or island',
                      'floor to top of left cabinet or island',
                      'middle of floor to top of adjacent cabinet or island'
                    ]
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_27',
                    string: 'Use the shorter of the three measurements for the overall height needed. Most ranges have adjustable legs, so you can level the appliance for best performance.'
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  image: {
                    id: 'image_12',
                    src: RANGE_ANIMATIONS.SLIDE_IN_HEIGHT,
                    alt: 'Range Slide-in Measure Height',
                    size: '100%',
                  },
                  modifiers: {
                    marginOverride: 6
                  }
                },
                {
                  tip: {
                    id: 'tip_5',
                    strings: [
                      'Allow up to six inches between the cooktop and range hood to prevent heat damage.'
                    ]
                  },
                  modifiers: {
                    hasBorder: true,
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_28',
                    string: 'Most slide-in ranges are 36"-40" in height.',
                    isTiny: true
                  }
                }
              ]
            },
            {
              id: 'tab_3',
              label: 'Freestanding',
              content: [
                {
                  sections: {
                    id: 'sections_5',
                    items: [
                      {
                        image: {
                          id: 'image_12',
                          src: RANGE_IMAGES.FREESTANDING,
                          alt: 'Freestanding Height',
                          size: '45%',
                          subHeader: 'Freestanding'
                        },
                        modifiers: {
                          ranges: true
                        }
                      }
                    ]
                  },
                  modifiers: {
                    marginOverride: 6
                  }
                },
                {
                  text: {
                    id: 'text_29',
                    string: 'Measure from the floor to the top of your cabinet. Floors can warp so take three measurements.'
                  },
                  modifiers: {
                    marginOverride: 2
                  }
                },
                {
                  list: {
                    id: 'list_4',
                    items: [
                      'floor to top of right cabinet',
                      'floor to top of left cabinet',
                      'middle of floor to top of adjacent cabinet'
                    ]
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_30',
                    string: 'Use the shorter of the three measurements for the overall height needed. Most ranges have adjustable legs, so you can level the appliance for best performance.'
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  image: {
                    id: 'image_13',
                    src: RANGE_ANIMATIONS.FREESTANDING_HEIGHT,
                    alt: 'Freestanding Range Measure Height Gif',
                    size: '100%',
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  tip: {
                    id: 'tip_6',
                    strings: [
                      'Depending on the range you choose, the back control panel may add up to twelve inches to its height. Allow up to six inches between the cooktop and range hood to prevent heat damage.',
                    ]
                  },
                  modifiers: {
                    hasBorder: true,
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_31',
                    string: 'Most freestanding ranges are 36"-36.5" in height (without back control panel).',
                    isTiny: true
                  }
                }
              ]
            }
          ]
        }
      }
    ],
    footer: 'Next'
  },
  // Page 6
  {
    header: 'Step 5 of 5',
    sections: [
      {
        text: {
          id: 'text_32',
          string: 'Decide on Depth',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_33',
          string: 'Measure the depth from the back wall to the front edge of your cabinet.'
        }
      },
      {
        image: {
          id: 'image_14',
          src: RANGE_ANIMATIONS.RANGE_DEPTH,
          alt: 'Range Measure Depth',
          size: '100%',
        }
      },
      {
        text: {
          id: 'text_34',
          string: 'Allow 3 to 4 feet of space in front of your range to fully open the oven door and easily load or remove items.'
        }
      },
      {
        image: {
          id: 'image_15',
          src: RANGE_ANIMATIONS.RANGE_DOOR_DEPTH,
          alt: 'Range Door Measure Depth Swing Gif',
          size: '100%',
        }
      },
      {
        text: {
          id: 'text_35',
          string: 'For a more detailed measuring guide visit ',
          linkString: 'How to Measure a Range for Your Kitchen.',
          linkUrl: 'https://www.homedepot.com/c/ah/how-to-measure-a-range-for-your-kitchen/9ba683603be9fa5395fab901eea4acea'
        }
      }
    ],
    footer: 'Done'
  }
];